import {Outlet} from 'react-router-dom'
// material
import {styled} from '@material-ui/core/styles'

// components
import Logo from 'components/Logo'
import Box from '@material-ui/core/Box'
// ----------------------------------------------------------------------

const RootContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  width: '100%',
}))

const HeaderStyle = styled('header')(({theme}) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  height: '5rem',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '0 0 30px 30px',
  background: 'linear-gradient(135deg, #0EA4D9 0%, #13E9DD 100%)',
  flexShrink: 0,
}))

const FooterStyle = styled(Box)(({theme}) => ({
  width: '100%',
  height: '5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '30px 30px 0 0',
  background: 'linear-gradient(135deg, #0EA4D9 0%, #13E9DD 100%)',
  flexShrink: 0,
}))

const MainContent = styled(Box)(({theme}) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
  width: '100%',
  flexDirection: 'column',
  minHeight: 0, // Allow flex item to shrink
}))

const LogoContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexGrow: 1,
  marginBottom: theme.spacing(3),
}))

const OutletContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexGrow: 1,
  top: 0,
  flex: 2,
}))

// ----------------------------------------------------------------------

export default function LogoOnlyLayout() {
  return (
    <RootContainer>
      <HeaderStyle />

      <MainContent>
        <LogoContainer>
          <Logo />
        </LogoContainer>

        <OutletContainer>
          <Outlet />
        </OutletContainer>
      </MainContent>

      <FooterStyle />
    </RootContainer>
  )
}
